import type { TableProps } from '@risk-smart/themed-cloudscape-components/table';

import type { AggregationType } from '../types';

type ColumnWithAggregatedValueFormatter<T> = TableProps.ColumnDefinition<T> & {
  aggregatedValueFormatter?: (value: number) => string;
};

/**
 * Resolves the display formatter for a widget's aggregated value.
 *
 * Returns the `aggregatedValueFormatter` attached to the aggregation field's
 * column definition (see `FieldConfig.aggregatedValueFormatter`) only when a
 * field-based aggregation (sum/mean/min/max) is active. Count aggregations
 * never format — counts must keep rendering as plain integers (RSP-5735).
 */
export const getAggregatedValueFormatter = <T>(
  columnDefinitions:
    | readonly ColumnWithAggregatedValueFormatter<T>[]
    | undefined,
  aggregationType: AggregationType | undefined,
  aggregationField: keyof T | undefined
): ((value: number) => string) | undefined => {
  if (!aggregationType || aggregationType === 'count' || !aggregationField) {
    return undefined;
  }

  return columnDefinitions?.find((c) => c.id === aggregationField)
    ?.aggregatedValueFormatter;
};
